import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'providers/auth.service';

// Check if filter is already enabled
const LOCAL_STORAGE_PATH = 'chargeye-gdpr-privacy';
let initialValue = false;
try {
    initialValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_PATH) || 'false');
} catch (error) {
    console.error(error);
}

@Injectable({
    providedIn: 'root',
})
@UntilDestroy()
/**
 * This Service is used to hide sensitive data from the public
 */
export class GdprPrivacyService {
    private _gdprPrivacyEnabled$ = new BehaviorSubject<boolean>(initialValue);

    get enabled$() {
        return this._gdprPrivacyEnabled$;
    }
    constructor(private authService: AuthService) {
        this._gdprPrivacyEnabled$.pipe(untilDestroyed(this)).subscribe((enabled) => {
            try {
                localStorage.setItem(LOCAL_STORAGE_PATH, JSON.stringify(enabled));
            } catch (error) {
                console.error(error);
            }
        });

        // Uncomment the code below to enable GDPR filtering for all users

        // this.authService.ensureLoggedIn().then(() => {
        //     const isSystemAdmin = this.authService.getPermissions().isSystemAdmin;
        //     if (!initialValue && isSystemAdmin) {
        //         this.disableGdprPrivacy(); // Only unmask if admin
        //     } else {
        //         this.enableGdprPrivacy();
        //     }
        // })
    }

    disableGdprPrivacy() {
        if (this.authService.getPermissions().isSystemAdmin) {
            this._gdprPrivacyEnabled$.next(false);
        } else {
            this._gdprPrivacyEnabled$.next(true);
        }
    }

    enableGdprPrivacy() {
        this._gdprPrivacyEnabled$.next(true);
    }

    gdprPrivacyEnabled$() {
        return this._gdprPrivacyEnabled$.asObservable();
    }
    toggle() {
        this._gdprPrivacyEnabled$.next(!this._gdprPrivacyEnabled$.value);
    }
}
